import { ThankYouConfig } from '../types'

/**
 * Configuración por defecto de la página de gracias.
 *
 * Es la ÚNICA fuente de verdad: la usan la creación de landings, el mapeador
 * que lee la configuración guardada, la ruta pública `/gracias/:slug` y la
 * vista previa del constructor. Así una landing nueva —o una que nunca tocó
 * esta pestaña— ya llega con el paso final de WhatsApp montado, sin tener que
 * configurar nada a mano.
 */

/** Plantilla del mensaje dinámico. Las variables vacías eliminan su línea. */
export const DEFAULT_WHATSAPP_MESSAGE = `Hola, soy {{nombre}}.

Acabo de completar mi solicitud para implementar Sistema AVA.

Empresa: {{empresa}}
Ciudad: {{ciudad}}
Instagram: {{instagram}}
Publicidad actual: {{publicidad}}
Presupuesto disponible: {{presupuesto}}
Servicio que me interesa: {{servicio}}

Me gustaría recibir información sobre cómo implementar Sistema AVA en mi negocio.`

export const DEFAULT_REPLY_NOTE =
  'Nos pondremos en contacto contigo en un plazo máximo de 24 horas.'

export const DEFAULT_THANK_YOU: ThankYouConfig = {
  title: 'Hemos recibido tu solicitud.',
  subtitle: '',
  text: 'Nuestro equipo revisará la información de tu empresa y se pondrá en contacto contigo.',
  showCalendly: false,
  // El paso final de WhatsApp forma parte del diseño por defecto.
  showWhatsapp: true,
  whatsappEyebrow: 'Solo falta un paso',
  whatsappStepTitle: 'Abre WhatsApp',
  whatsappStepText:
    'Tu solicitud ya está preparada. Hemos recopilado la información que acabas de completar. Pulsa el botón para abrir WhatsApp: el mensaje ya está escrito, solo tienes que enviarlo.',
  whatsappLabel: 'Continuar por WhatsApp',
  whatsappMessage: DEFAULT_WHATSAPP_MESSAGE,
  showWhatsappPreview: true,
  replyNote: DEFAULT_REPLY_NOTE,
  showReplyNote: true,
  showHome: false,
}

/**
 * Completa una configuración guardada con los valores por defecto.
 *
 * Solo rellena las claves ausentes (`undefined`), así que nunca sobrescribe una
 * personalización válida: si el usuario desactivó WhatsApp, ese `false` se
 * conserva porque está definido.
 */
export function withThankYouDefaults(
  stored?: Partial<ThankYouConfig> | null,
): ThankYouConfig {
  const config = (stored ?? {}) as Partial<ThankYouConfig>
  const merged = { ...DEFAULT_THANK_YOU } as Record<string, unknown>
  for (const [key, value] of Object.entries(config)) {
    if (value !== undefined) merged[key] = value
  }
  return merged as unknown as ThankYouConfig
}
